"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadRentObjects = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _redux = require("../util/redux.js");

var loadRentObjects = function loadRentObjects(contractType, stationId, pickupStationId) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState, context) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch((0, _redux.asyncAction)({
                typePrefix: "RENT_OBJECTS/RENT_OBJECTS",
                loadPayload: function loadPayload() {
                  return context.api.rentObjects.getRentObjectTypes({
                    contractType: contractType,
                    stationId: stationId,
                    pickupStationId: pickupStationId
                  });
                }
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.loadRentObjects = loadRentObjects;